import { MediaType } from './enums';
import { KuxEventWithParam } from './events';

export enum UserActionType {
  login = 'LOGIN',
  selfSrv = 'SELF_SRV',
  continue = 'CONTINUE',
  details = 'DETAILS',
  buyTry = 'BUY_TRY',
  search = 'SEARCH',
  favoriteAdd = 'FAVORITE_ADD',
  favoriteRemove = 'FAVORITE_REMOVE',
  custom1 = 'CUSTOM_1',
  custom2 = 'CUSTOM_2',
  custom3 = 'CUSTOM_3',
  deepLink = 'DEEP_LINK',
}

export enum LoginType {
  internalLogin = 'Internal Login',
  externalLogin = 'External Login',
  pinCode = 'Pin Code',
  silentLogin = 'Silent Login',
}

export class UserActionEventArgsBase extends KuxEventWithParam {
  readonly action: UserActionType;

  constructor(action: UserActionType, data?: Partial<KuxEventWithParam>) {
    super('userAction', data);
    this.action = action;
  }
}

export class UserLoginEventArgs extends UserActionEventArgsBase {
  constructor(loginType?: LoginType, loginRefresh = false) {
    super(UserActionType.login, {
      param1: loginType,
      param2: loginRefresh ? 'refresh' : undefined,
    });
  }
}

export class UserSearchEventArgs extends UserActionEventArgsBase {
  constructor(query: string) {
    super(UserActionType.search);
    this.param1 = query;
  }
}

export class UserEnteredSelfServiceEventArgs extends UserActionEventArgsBase {
  constructor() {
    super(UserActionType.selfSrv);
  }
}

export class UserClickedContinueEventArgs extends UserActionEventArgsBase {
  constructor(assetId: string, mediaType: MediaType) {
    super(UserActionType.continue);
    this.param1 = assetId;
    this.param2 = mediaType;
  }
}

export class UserClickedContentDetailsEventArgs extends UserActionEventArgsBase {
  constructor(assetId: string, mediaType: MediaType) {
    super(UserActionType.details);
    this.param1 = assetId;
    this.param2 = mediaType;
  }
}

export class UserPurchaseTryEventArgs extends UserActionEventArgsBase {
  constructor(assetId: string, mediaType: MediaType) {
    super(UserActionType.buyTry);
    this.param1 = assetId;
    this.param2 = mediaType;
  }
}
export class UserFavoriteAddEventArgs extends UserActionEventArgsBase {
  constructor(assetId: string, mediaType: MediaType) {
    super(UserActionType.favoriteAdd);
    this.param1 = assetId;
    this.param2 = mediaType;
  }
}
export class UserFavoriteRemoveEventArgs extends UserActionEventArgsBase {
  constructor(assetId: string, mediaType: MediaType) {
    super(UserActionType.favoriteRemove);
    this.param1 = assetId;
    this.param2 = mediaType;
  }
}

export class UserCustomActionEventArgs extends UserActionEventArgsBase {
  constructor(action: UserActionType.custom1 | UserActionType.custom2) {
    super(action);
  }
}

export class UserClickedDeepLinkEventArgs extends UserActionEventArgsBase {
  constructor(assetId: string, providerName: string, infoPageDisplayed: boolean) {
    super(UserActionType.deepLink, {
      param1: assetId,
      param2: providerName,
      param3: infoPageDisplayed ? 'true' : 'false',
    });
  }
}
